import { Avatar, cn } from '@quickmd-llc/design-system'
import { useSelector } from 'store/hooks/useSelector'
import { useLocalMediaTrackState } from '../hooks/useLocalMediaTrackState'
import { LocalVideo } from './LocalVideo'

export function VideoThumbnail() {
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  const { FirstName, LastName, ImageUrl } = profile || {}
  const { isVideoTrackOn } = useLocalMediaTrackState()
  return (
    <div
      className={cn(
        'right-sp-2 top-sp-2 flex h-[112px] w-[84px] flex-col items-center justify-center overflow-hidden rounded-large border border-border-dark bg-[#27242C]',
        isVideoTrackOn ? 'border-border-dark' : 'border-[#27242C]',
      )}>
      {
        isVideoTrackOn ?
          <LocalVideo />
          // @ts-expect-error TS2375 -- MIGRATION: not approved, fix when encountered
        : <Avatar name={`${FirstName} ${LastName}`} src={ImageUrl} size='m' />
      }
    </div>
  )
}
